import { LegalDocument } from '../../components/legal/LegalDocument';
import { privacyContent } from '../../content/legal/privacyContent';

export function IosPrivacy() {
  return (
    <LegalDocument
      content={privacyContent}
      platform="ios"
      seoDescription="LuvLust iOS Privacy Policy. Learn how we collect, use, and protect your information."
      seoKeywords="luvlust ios privacy policy, data protection, couples app privacy"
    />
  );
}
